/* header-language.js — ouverture/fermeture du sélecteur de langue du header.
 *
 * Délégation au niveau du document : le header peut être re-rendu (header
 * collant, éditeur de thème) sans que les écouteurs soient perdus.
 */
(function () {
  'use strict';

  if (window.__headerLangReady) return;
  window.__headerLangReady = true;

  function closeAll(except) {
    var open = document.querySelectorAll('[data-header-lang].is-open');
    Array.prototype.forEach.call(open, function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      var btn = el.querySelector('.header-lang__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var wrap = target.closest('[data-header-lang]');
    closeAll(wrap);
    if (!wrap) return;

    if (target.closest('.header-lang__btn')) {
      e.preventDefault();
      var isOpen = wrap.classList.toggle('is-open');
      wrap.querySelector('.header-lang__btn').setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    var item = target.closest('.header-lang__item');
    if (!item) return;

    e.preventDefault();
    var form = wrap.querySelector('form');
    var input = form && form.querySelector('[name="locale_code"]');
    if (!form || !input) return;
    input.value = item.dataset.lang;
    form.submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
